<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    width="550"
    transition="dialog-bottom-transition"
  >
    <v-card v-if="order != null">
      <v-card-title>
        <v-row>
          <v-col>
            <h6>ออเดอร์</h6>
            <h1 class="font-weight-bold black--text">
              {{ order.order_reference }}
            </h1>
          </v-col>
          <v-col class="text-right">
            <h6>จำนวนเงินที่ต้องชำระ</h6>
            <h1 class="font-weight-bold primary--text">
              ฿ {{ order.amount.total | numFormat("0,0.00") }}
            </h1>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 540px;">
        <img :src="order.payment.payment_image_url" style="width:100%;" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" depressed @click="close()">ปิด</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "@/services";
import { monthList } from "@/utils/Constants";
import moment from "moment";

export default {
  name: "payment-dialog",
  props: {
    showDialog: { default: false },
    order: { default: null },
  },
  data() {
    return {
      loading: false,
      isPass: false,
      isError: false,
      form: null,
      drivers: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    showDialog: function(newVal, oldVal) {},
  },
  methods: {
    close() {
      this.isError = false;
      this.$emit("close");
    },
  },
};
</script>
